import {
  IS_LOGIN,
  IS_LOGOUT,
  SHOW_LOADING,
  HIDE_LOADING,
  PERSIST_AUTH,
  CLEAR_STORE,
  LOGIN_ERROR,
  CLEAR_LOGIN_ERROR,
  WEBAUTHN_PREAUTH,
  WEBAUTHN_FLOW_RESET,
} from "../actions/types";
import { verifyFlag } from "../../utils/secureFlag";

let authState = sessionStorage.getItem("token");
let analyst_id = sessionStorage.getItem("analyst_id");
let analystName = sessionStorage.getItem("analystName");

// Authorization flags are signed + token-bound; verifyFlag returns null if the
// stored value was tampered with in sessionStorage. Anything unverifiable is
// treated as non-privileged.
const _isAdmin = verifyFlag(sessionStorage.getItem("isAdmin"), authState);
const _isSuperAdmin = verifyFlag(sessionStorage.getItem("isSuperAdmin"), authState);
const _accountRole = verifyFlag(sessionStorage.getItem("accountRole"), authState);
const _tabsAccessible = verifyFlag(sessionStorage.getItem("tabsAccessible"), authState);

const INITIAL_STATE = {
  token: authState,
  loading: false,
  analyst_id: analyst_id,
  isAdmin: !!_isAdmin?.status,
  isSuperAdmin: !!_isSuperAdmin?.status,
  analystName: analystName,
  accountRole: _accountRole ?? null,
  tabsAccessible: _tabsAccessible?.tabs ?? null,
  login_error: false,
  isAuthenticated: authState !== null,
  // WebAuthn pre-auth flow: null when idle, else { next_step, preauth_ticket, request_id }.
  webauthn: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case IS_LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        analyst_id: action.payload,
        isAdmin: action.isAdmin,
        isSuperAdmin: action.isSuperAdmin,
        token: action.token,
        analystName: action.analystName,
        accountRole: action.accountRole,
        tabsAccessible: action.tabsAccessible,
        loading: false,
        login_error: false,
        webauthn: null,
      };
    case WEBAUTHN_PREAUTH:
      return {
        ...state,
        loading: false,
        login_error: false,
        webauthn: {
          next_step: action.next_step,
          preauth_ticket: action.preauth_ticket,
          request_id: action.request_id,
          analyst_id: action.analyst_id,
          is_admin: action.is_admin,
          analyst_name: action.analyst_name,
          role: action.role,
          tabs_accessible: action.tabs_accessible,
          force_enroll: action.force_enroll,
        },
      };
    case WEBAUTHN_FLOW_RESET:
      return { ...state, webauthn: null };
    case IS_LOGOUT:
      return {
        token: null,
        isAuthenticated: false,
        loading: false,
        analyst_id: null,
        login_error: false,
      };
    case LOGIN_ERROR:
      return { ...state, login_error: true };
    case CLEAR_LOGIN_ERROR:
      return { ...state, login_error: false };
    case PERSIST_AUTH:
      return { ...state, isAuthenticated: true, login_error: false };
    case CLEAR_STORE:
      return {
        isAuthenticated: false,
        loading: false,
        analyst_id: null,
        login_error: false,
      };
    case SHOW_LOADING:
      return { ...state, loading: true };
    case HIDE_LOADING:
      return { ...state, loading: false };
    default:
      return state;
  }
};
